import { useCallback, useEffect, useRef, useState } from 'react'

import styles from '../invictusLanding.module.css'
import scholarshipicon1 from "../../../assets/scholarship_icon1.svg"
import jeeicon2 from "../../../assets/jee_icon2.svg"
import skillicon3 from "../../../assets/skill_icon3.svg"
import readinessicon4 from "../../../assets/readiness_icon4.svg"
import edgeicon5 from "../../../assets/edge_icon5.svg"
import backImg from "../../../assets/admission_test_pattern.svg"

const slides = [
    {
        title: "Up to 100%* Scholarship & Cash Awards*",
        subtitle: "For top performing students",
        image: scholarshipicon1,
    },
    {
        title: "ASSESS : Go beyond the obvious",
        subtitle: "ACE uses structured, precision crafted tests to decode how students approach problems; not just whether they solve them.",
        image: jeeicon2,
    },
    {
        title: "CALIBRATE : Know your edge",
        subtitle: "With topic-wise diagnostics, timeon-question tracking, accuracy heatmaps and national rank benchmarking, ACE helps students understand where they stand and how they compare with the county’s best minds.",
        image: skillicon3,
    },
    {
        title: "ENGINEER Design your success strategy",
        subtitle: "Every test is followed by personalised guidance, combining mentoring, academic planning and micro-targeted performance strategies.",
        image: readinessicon4,
    },
    {
        title: "Gateway to IITs",
        subtitle: "Opportunity to join the most advanced JEE Preparation program tailored for IIT mindset - Aakash INVICTUS.",
        image: edgeicon5,
    },
];

const gradients = [
    "linear-gradient(to bottom, #133162, #3779B8)",
    "linear-gradient(to bottom, #133162, #3793B8, #3793B8)",
    "linear-gradient(to bottom, #3779B8, #3748B8)",
    "linear-gradient(to bottom, #3779B8, #37B6B8, #135562)",
    "linear-gradient(to bottom, #3793B8, #132B62)"
];

const InvictusVerticalCarousal = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const observerRef = useRef(null);
    const isScrollingRef = useRef(false);
    const blockerRef = useRef(null);
    const lastActiveIndexRef = useRef(0);
    const debounceTimeoutRef = useRef(null);

    const scrollToSection = useCallback((index) => {
        if (!isVisible) return
        const section = document.getElementById(`section${index}`);
        if (section) {
            isScrollingRef.current = true;
            setTimeout(() => {
                section.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });

                setTimeout(() => {
                    isScrollingRef.current = false;
                }, 1000);
            }, 100);
        }
    }, [isVisible]);

    const updateActiveIndex = useCallback((newIndex) => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            if (newIndex !== lastActiveIndexRef.current) {
                setActiveIndex(newIndex);
                lastActiveIndexRef.current = newIndex;
            }
        }, 50);
    }, []);

    useEffect(() => {
        const callback = (entries) => {
            if (isScrollingRef.current) return;

            let maxRatio = 0;
            let targetIndex = activeIndex;

            entries.forEach((entry) => {
                if (entry.isIntersecting && entry.intersectionRatio > maxRatio && entry.intersectionRatio > 0.3) {
                    const sectionId = entry.target.id;
                    const sectionIndex = parseInt(sectionId.replace('section', ''));
                    if (!isNaN(sectionIndex)) {
                        maxRatio = entry.intersectionRatio;
                        targetIndex = sectionIndex;
                    }
                }
            });

            if (maxRatio > 0.5 && targetIndex !== lastActiveIndexRef.current) {
                updateActiveIndex(targetIndex);
            }
        };

        const options = {
            root: null,
            rootMargin: "-20% 0px -20% 0px",
            threshold: [0.0, 0.3, 0.5, 0.7, 1.0],
        };

        observerRef.current = new IntersectionObserver(callback, options);

        const slideElements = document.querySelectorAll('.slide');
        slideElements.forEach((el) => {
            observerRef.current.observe(el);
        });

        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, []);

    const handleNavClick = (index) => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        setActiveIndex(index);
        lastActiveIndexRef.current = index;
        scrollToSection(index);
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.3,
            }
        );

        const current = blockerRef.current;
        if (current) observer.observe(current);

        return () => {
            if (current) observer.unobserve(current);
        };
    }, []);

    return (
        <div
            ref={blockerRef}
            className={styles.admissiontest_wrapper}
            style={{
                background: gradients[activeIndex],
                transition: 'background 0.6s ease-in-out' // Slightly faster transition
            }}
        >
            <div className={styles.content_wrapper}>
                <div className={styles.admissiontest_header}>
                    <h2>About Invictus Ace</h2>
                    <p>
                        Scholarship exam for admission into Aakash Invictus program.
                    </p>
                </div>

                <div className={styles.side_nav}>
                    {slides.map((_, index) => (
                        <div
                            key={index}
                            className={`${styles.nav_dot} ${activeIndex === index ? styles.active : ""}`}
                        >
                            <button className={styles.no_button} onClick={() => handleNavClick(index)}>
                                {`0${index + 1}`}
                            </button>
                        </div>
                    ))}
                </div>

                <div className={styles.bottom_nav}>
                    {slides.map((_, index) => (
                        <div
                            key={index}
                            className={`${styles.nav_dot} ${activeIndex === index ? styles.active : ""}`}
                        >
                            <button className={styles.no_button} onClick={() => handleNavClick(index)}>
                                {`0${index + 1}`}
                            </button>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{ padding: '30vh 0', position: 'relative' }}>
                {
                    slides.map(({ image, subtitle, title }, index) => (
                        <div
                            key={index}
                            className={`${styles.card_wrapper} slide`}
                            id={`section${index}`}
                            style={{
                                position: index === slides.length - 1 ? "sticky" : 'static',
                                top: index === slides.length - 1 ? '0px' : 'auto'
                            }}
                        >
                            <div className={styles.card_inner_wrapper}>
                                <div className={`${styles.card} ${activeIndex === index ? styles.active_card : ""}`}>
                                    <div className={styles.card_content}>
                                        <h2>{title}</h2>
                                        <p>{subtitle}</p>
                                    </div>
                                    <img className={styles.backImg} src={backImg} alt="backimg" />
                                    <img src={image} alt={title} className={styles.backImg2} />
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default InvictusVerticalCarousal